import { PositionOverview } from '../types'
import { NativeAssetInfo } from '@/config/chain/types'
import { AaveData } from '@/features/sparklend/common/data/market-info/aave-data-layer/query'
import { EModeCategoryId } from '@/features/sparklend/common/data/market-info/emode'
import { MarketInfo } from '@/features/sparklend/common/data/market-info/marketInfo'
import { updatePositionSummary } from '@/features/sparklend/common/data/market-info/updatePositionSummary'

export interface GetUpdatedPositionOverviewParams {
  marketInfo: MarketInfo
  aaveData: AaveData
  selectedEModeCategoryId: EModeCategoryId
  currentEModeCategoryId: EModeCategoryId
  nativeAssetInfo: NativeAssetInfo
}

export function getUpdatedPositionOverview({
  marketInfo,
  aaveData,
  currentEModeCategoryId,
  selectedEModeCategoryId,
  nativeAssetInfo,
}: GetUpdatedPositionOverviewParams): PositionOverview | undefined {
  if (currentEModeCategoryId === selectedEModeCategoryId) {
    return undefined
  }

  const { healthFactor, maxLoanToValue: maxLTV } = updatePositionSummary({
    marketInfo,
    aaveData,
    eModeCategoryId: selectedEModeCategoryId,
    nativeAssetInfo,
  })

  return {
    healthFactor,
    maxLTV,
  }
}
